import { createApp } from 'vue';
// import "./style.css";
import App from './App.vue';

import 'bootstrap'; // Hier importieren wir das Bootstrap JavaScript

import router from './router';
import { createPinia } from 'pinia';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowRightFromBracket,
  faArrowRightToBracket,
  faBars,
  faCertificate,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircleCheck,
  faCircleInfo,
  faClipboard,
  faFileInvoice,
  faFolder,
  faGear,
  faHashtag,
  faHouse,
  faKaaba,
  faLink,
  faListCheck,
  faMagnifyingGlass,
  faMagnifyingGlassPlus,
  faMinus,
  faPallet,
  faPause,
  faPen,
  faPlay,
  faPlug,
  faPlugCircleXmark,
  faPlus,
  faRotate,
  faServer,
  faTable,
  faTableList,
  faTag,
  faTrash,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faArrowRightToBracket,
  faArrowRightFromBracket,

  faBars,

  faCertificate,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircleCheck,
  faCircleInfo,
  faClipboard,

  faFolder,
  faFileInvoice,

  faGear,

  faHashtag,
  faHouse,

  faKaaba,

  faLink,
  faListCheck,

  faMinus,
  faMagnifyingGlass,
  faMagnifyingGlassPlus,

  faPallet,
  faPause,
  faPen,
  faPlay,
  faPlug,
  faPlugCircleXmark,
  faPlus,

  faRotate,

  faServer,

  faTable,
  faTableList,
  faTag,
  faTrash,

  faUsers
);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const app = createApp(App);

app.use(router);
app.use(createPinia());
app.component('font-awesome-icon', FontAwesomeIcon);
app.mount('#app');
